import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconArrowLeftBlack from 'yoda-core-components/lib/assets/svg/left_arrow_2023.svg';
import Cash from '../../assets/svg/cash.svg';
import { isPDPPage } from '../../helpers/Utils/pageType';
import { selectDeviceType, selectFeatureFlags } from '../../selectors/ContextSelector';
import { fetchRebateData } from '../../actions/RebatesAction';
import EcoRebatesModalNew from './EcoRebatesModalNew';
import SlidePanel from '../SlidePanel/SlidePanel';
import * as styles from './EcoRebates.css';

const cx = classNames.bind(styles);

const EcoRebatesNew = ({ skuId = '', fromMiniPDP = false, ecoRebatebBorderStyle = [] }) => {
    const { isMobile } = useSelector((state) => selectDeviceType(state));
    const [showDialog, setShowDialog] = useState(false);
    const { enableEcoRebateNew = false } = useSelector(selectFeatureFlags);

    const rebateInfo = useSelector(
        (state) =>
            state?.rebatesInfo?.data?.rebateResponse?.productRebateDetails[0]?.rebatePrograms[0] ||
            []
    );
    const rebateError = useSelector((state) => state?.rebatesInfo?.error || false);

    const dispatch = useDispatch();

    /* istanbul ignore next */
    const handleOnClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowDialog(true);
    };

    useEffect(() => {
        dispatch(fetchRebateData(skuId));
    }, [skuId]);

    /* istanbul ignore next */
    const handleOnClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowDialog(false);
    };

    const renderHeaderEcorebateSlider = () => {
        return (
            <div className={`${dt(['flex', 'py-6', 'px-6', 'pb-0', 'justify-between'])}`}>
                <span
                    className={`${dt(['text-black', 'font-semibold', 'font-sans', 'text-xlarge'])}`}
                >
                    Rebates Available
                </span>
                <button
                    onClick={handleOnClose}
                    className={`${dt([
                        'flex',
                        'items-center',
                        'justify-center',
                    ])} rebatesCloseButton`}
                >
                    {fromMiniPDP ? (
                        <Icon
                            iconType="svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            pathClassName={cx('panelIcon')}
                        >
                            <IconArrowLeftBlack />
                        </Icon>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M25.051 8.64609C25.5196 8.17746 25.5196 7.41767 25.051 6.94904C24.5823 6.48041 23.8225 6.48041 23.3539 6.94904L16 14.3029L8.64609 6.94904C8.17746 6.48041 7.41766 6.48041 6.94903 6.94904C6.4804 7.41767 6.48041 8.17746 6.94903 8.64609L14.3029 16L6.94904 23.3539C6.48041 23.8225 6.48041 24.5823 6.94904 25.051C7.41766 25.5196 8.17746 25.5196 8.64609 25.051L16 17.6971L23.3539 25.051C23.8225 25.5196 24.5823 25.5196 25.051 25.051C25.5196 24.5823 25.5196 23.8225 25.051 23.3539L17.6971 16L25.051 8.64609Z"
                                fill="#202020"
                            />
                        </svg>
                    )}
                </button>
            </div>
        );
    };
    return skuId && (!isEmpty(rebateInfo) || !isEmpty(rebateError)) ? (
        <div className={dt([...ecoRebatebBorderStyle])} data-automation-id="ecorebatesnew-block">
            <button
                className={dt([
                    'cursor-pointer',
                    'font-sans',
                    !isEmpty(ecoRebatebBorderStyle) ? 'py-2' : 'py-0',
                    'text-black',
                    'text-sm',
                    'underline',
                ])}
                data-automation-id={`product-eco-rebate-${skuId}`}
                onClick={handleOnClick}
                type="button"
            >
                <Icon iconType="svg" width="24px" height="24px" viewBox="0 0 24 24">
                    <Cash />
                </Icon>
                <span className={dt(['leading-5', 'pl-2', 'text-sm', 'text-black', 'underline'])}>
                    {rebateInfo?.amountLabel || 'Rebates not Available'}
                </span>
                {enableEcoRebateNew && (
                    <SlidePanel
                        isOpenPanel={showDialog}
                        onClosePanel={handleOnClose}
                        panelTitleAlignment="justify"
                        showBackIcon={false}
                        showHeaderIcon={false}
                        panelHeaderRenderer={renderHeaderEcorebateSlider}
                        panelWidth={cx('panelWidth')}
                    >
                        <EcoRebatesModalNew
                            skuId={skuId}
                            rebateInfoPdp={rebateInfo}
                            isPDPPage={isPDPPage}
                            rebateErrorPdp={rebateError}
                            fromMiniPDP={fromMiniPDP}
                        />
                    </SlidePanel>
                )}
            </button>
        </div>
    ) : null;
};

EcoRebatesNew.propTypes = {
    skuId: string.isRequired,
};

export default EcoRebatesNew;
